import { useEffect, useState, useRef, useContext } from "react";

//npm imports
import styled, { withTheme } from "styled-components/macro";
import { API } from "../../Consts/Api";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import brainsterNextCover from "./Static/brainster-next-cover.jpg";
import ultimathCover from "./Static/ultimath-cover.jpg";

//component imports

import {
  Caption12,
  Header25,
  Header32,
  HeaderLarge40,
  Subheader18,
  Text12,
  Text14,
  Text18,
} from "../../Components/Text/Text";
//other imports
import result_page_background from "./Static/hero-bars.png";
import { GlobalContext } from "../../Context/GlobalContext";
import Footer from "../../Pages/Homepage/Blocks/Footer/Footer.jsx";
import UltimathWhiteLogo from "../../Components/UltimathLogo/UltimathWhiteLogo.jsx";
import BrainsterNextLogo from "./Blocks/BrainsterNextLogo.jsx";
import NUCollegeLogo from "./Blocks/NUCollegeLogo.jsx";



//styled components
const ResultWrapper = styled.main`
  min-height: 100vh;
  background-color: ${(props) => props.theme.forestGreen};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0px 00px 0;
  font-family: Inter;
  position: relative;
  background-image: url(${result_page_background});
  background-position: top;
  background-repeat: no-repeat;

  .mt-12 {
    margin-top: 12px;
  }
  & > section {
    width: 100%;
    height: max-content;
    min-height: 500px;
    padding: 40px 0 0 0;
    .brainster-logo-container {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 42px;
    }
    .brainster-header-container {
      padding-bottom: 154px;
      position: relative;
      & > img {
        position: absolute;
      }
      & > img:first-of-type {
        top: 3%;
        right: 10%;

        z-index: 0;
      }

      & > img:last-of-type {
        top: 85%;
        left: 1%;
        z-index: 1;
      }
    }

    ${Header32}, ${Text18} {
      text-align: center;
    }

    ${Header32} {
      width: 47%;
      margin: 0 auto 16px auto;
      z-index: 3;
      position: relative;
    }

    ${Text18} {
      margin-bottom: 40px;
    }

    .result-content-container {
      width: 100%;
      min-width: 515px;
      margin: 80px auto 0;
      background-color: ${(props) => props.theme.warmBeige};
      position: relative;

      & > ${Text12} {
        display: none;
      }
      & > img {
        position: absolute;
        bottom: 30%;
        right: 0;
      }
      .result-code-container {
        width: 86%;
        max-width: 1240px;
        background-color: ${(props) => props.theme.neonYellow};
        transform: translateY(-154px);
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 2;
        padding: 48px 0;
        p,
        h4 {
          text-align: center;
        }
        ${Caption12} {
          margin-bottom: 20px;
          color: #005840;
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
        }
        ${HeaderLarge40} {
          margin-bottom: 16px;
          text-decoration: underline;
        }
        ${Text14} {
          margin-bottom: 12px;
          max-width: 432px;
          font-size: 12px;
        }
      }
      .refer-friend-container {
        width: 42%;
        max-width: 612px;
        border-bottom: 1px solid ${(props) => props.theme.veryLightGray};
        margin: 0 auto;
        padding-bottom: 64px;
        transform: ${(props) => (props.isResult ? "" : "translateY(-94px)")};
        & > ${Text14} {
          margin-bottom: 20px;
        }
        .copy-link-input-container {
          width: 100%;
          height: 64px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: ${(props) => props.theme.forestGreen};
          border-radius: 4px;
          padding: 0px 24px;
          margin-bottom: 8px;
          & > div {
            width: 85%;
            display: flex;
            align-items: center;
            svg {
              width: 24px;
              margin-right: 24px;
            }
            input {
              font-family: "Raleway", sans-serif;
              color: ${(props) => props.theme.white};
              width: calc(100% - 48px);
              background: unset;
              border: none;
              font-weight: 500;
              &:focus,
              &:active,
              &:visited {
                outline: none;
                box-shadow: none;
                border: none;
              }
            }
          }
          ${Text14} {
            color: ${(props) => props.theme.neonYellow};
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
    .cta-container {
      width: 100%;
      background-color: ${(props) => props.theme.warmBeige};
      min-width: 515px;
      padding-top: 64px;
      ${Header25} {
        color: #005840;
        font-size: 18px;
        line-height: 24px;
      }
      & > div:first-of-type {
        display: block;
      }
      & > p {
        width: 85%;
        max-width: 1030px;
        margin: 0 auto 65px auto;
        text-align: center;
      }
      .blogs-container {
        width: 100%;
        display: flex;
        justify-content: center;
        gap: 15px;
        margin-top: 26px;
        padding-bottom: 180px;
      }
      .blogs-container .ultimath-cover-wrap,
      .blogs-container .brainster-next-cover-wrap {
        position: relative;
        cursor: pointer;
        overflow: hidden;

        img {
          width: 100%;
          height: auto;
          transition: transform 0.3s ease;
        }

        &:hover img {
          transform: scale(1.2);
        }
      }
      .blogs-container .ultimath-cover-wrap .overlay,
      .blogs-container .brainster-next-cover-wrap .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: end;
        padding-left: 32px;
        padding-bottom: 32px;
        z-index: 1; /* Ensures the overlay stays on top of the image */
      }
      .blogs-container .ultimath-cover-wrap .overlay {
        background: radial-gradient(
          232.98% 151.16% at 64.3% -37.28%,
          rgba(205, 245, 69, 0) 0%,
          #cdf545 80.84%
        );
      }
      .blogs-container .brainster-next-cover-wrap .overlay {
        background: radial-gradient(
          232.98% 151.16% at 64.3% -37.28%,
          rgba(116, 151, 255, 0) 0%,
          #7497ff 80.84%
        );
      }
      .blogs-container .brainster-next-cover-wrap .overlay p.title,
      .blogs-container .ultimath-cover-wrap .overlay p.title {
        font-size: 14px;
        line-height: 18px;
        margin-top: 10px;
      }
      .blogs-container .brainster-next-cover-wrap .overlay p.title {
        color: #fff;
      }
      .blogs-container .ultimath-cover-wrap .overlay p.title {
        color: #024f40;
      }
    }
  }
  @media (max-width: 1100px) {
    & > section {
      .brainster-header-container {
        & > img:first-of-type {
          right: 4%;
        }
      }
      ${Header32} {
        width: 66%;
      }
      .refer-friend-container {
        width: 90% !important;
      }

      .cta-container {
        .blogs-container {
          flex-direction: column;
          align-items: center;
          gap: 48px;
        }
      }
    }
  }
  @media (max-width: 768px) {
    padding: 30px 0 0px 0;
    & > section {
      .result-content-container,
      .cta-container {
        min-width: 420px;
      }
      ${Header32} {
        width: 85%;
        margin: 0 auto 16px auto;
      }

      ${Subheader18} {
        margin-bottom: 40px;
      }
    }
  }
  @media (max-width: 550px) {
    padding: 0px;
    & > section {
      width: 100%;
      padding-top: 0px;
      background-image: none;
      .brainster-header-container {
        & > img {
          display: none;
        }
        padding-top: 59px;
        padding-bottom: ${(props) => (props.isResult ? "194px" : "0px")};
        display: flex;
        flex-direction: column;
        align-items: center;
        .brainster-logo-container {
          margin-bottom: 32px;
          svg {
            path {
              fill: ${(props) => props.theme.white};
            }
          }
        }
        ${Header32} {
          font-size: 25px;
          line-height: 30px;
          font-weight: 500;
          width: 80%;
          margin: 50px auto 24px auto;
        }
        ${Text18} {
          width: 80%;
          margin-bottom: 0;
        }
        ${Header32}, ${Subheader18} {
          color: ${(props) => props.theme.white};
        }
      }
      .result-content-container {
        min-width: 290px;
        margin-top: 120px;
        /* margin-top: -41px; */
        padding-left: 16px;
        padding-right: 16px;
        & > ${Text12} {
          width: 90%;
          margin: 0 auto;
          text-align: center;
          line-height: 18px;
          padding-bottom: 40px;
          border-bottom: 1px solid ${(props) => props.theme.veryLightGray};
          display: ${(props) => (props.isResult ? "" : "block")};
          transform: translateY(-64px);
        }
        & > img {
          display: none;
        }
        .result-code-container {
          width: 100%;
          padding-left: 20px;
          padding-right: 20px;

          transform: translateY(-94px);
          & > p:last-of-type {
            /* display: none; */
          }
        }
        .refer-friend-container {
          padding-bottom: 42px;
          border-bottom: unset;
          margin-bottom: 0px;
          & > ${Text14} {
            margin-bottom: 14px;
          }
          .copy-link-input-container {
            padding: 0 18px;
            & > div {
              svg {
                margin-right: 18px;
              }
            }
          }
        }
        .refer-friend-container {
          margin-top: ${(props) => (props.isResult ? "-30px" : "72px")};
        }
      }
      .cta-container {
        min-width: 290px;
        padding: 0px 0px 56px 0px;
        position: relative;
        z-index: 9;
        & > div:first-child {
          display: block;
          width: 90%;
          height: 1px;
          background-color: ${(props) => props.theme.veryLightGray};
          margin: 0px auto 42px auto;
        }
        & > ${Header25} {
          font-size: 18px;
          line-height: 30px;
          font-weight: 500;
        }
        .blogs-container {
          width: 100%;
          margin: 45px 0 0 0;
          padding-bottom: 45px;
          flex-direction: column;
          padding-left: 16px;
          padding-right: 16px;
        }
      }
    }
  }
  @media (max-width: 350px) {
    .result-code-container {
      background-size: contain;
      background-position: right;
    }
  }
`;

const HeroOverlay = styled.div`
  width: 100%;
  background: radial-gradient(
    56.6% 77.35% at 50% -7.65%,
    /* Adjust the position to start from the top */ rgba(205, 245, 69, 0.4) 0%,
    /* Light color at the top */ rgba(0, 88, 64, 0) 100%
      /* Darker color at the bottom */
  );
  position: absolute;
  top: 0;
  left: 0;
  height: 340px;
`;

const DemoResultContainer = styled.div`
  width: 100%;
  height: max-content;
  display: flex;
  flex-direction: column;
  align-items: center;

    .ultimath-link {
      background: #005840; 
      color: #cdf545;
      padding: 2px 5px;
      font-family: Ligo;
    }

  .button-container {
    width: auto;
    margin-top: 24px;
    text-align:center;

    div {
      line-height:25px;
      display: block;
    }

    .small-text {
      font-size: 0.8rem;
    }

    .demo {
      border-radius: 8px;
      background: linear-gradient(350deg, #ffb3d3 -6.34%, #fff 164.35%);
      box-shadow: 0px 0px 10px 0px #ffb3d3;
      padding: 5px 6px;
    }

    a.cta-link {
      background: #005840;
      color: #cdf545;
      border-radius: 6px;
      padding: 16px;
      font-family: Inter;
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
      text-transform: uppercase;
      display: inline-block;
      margin: 8px;
      font-family: Ligo;
      font-size: 1.5rem;
      
    }
  }
`;

const MemoryMatrixResult = styled.div`
  width: 250px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 6px;
  background: #ffb3d3;
  padding: 16px;
  color: #81003b;
  font-family: Inter;
  margin-top: 8px;
  text-transform: uppercase;
  margin-bottom: 24px;

  p.header {
    font-size: 14px;
    font-weight: 500;
    text-align: left !important;
  }

  p.score {
    font-size: 14px;
    font-weight: 500;
    line-height: 30px;
    margin-bottom: 16px;
  }
  p.final-score {
    font-weight: 600;
  }
`;
export const BlogCta = styled.div`
  width: 480px;
  height: 180px;
  border-radius: 90px;
  position: relative;
  background-color: ${(props) => props.theme.violet};
  background-size: cover;
  background-repeat: no-repeat;
  border: 1px solid ${(props) => props.theme.black};
  ${Header25} {
    max-width: 164px;
    font-weight: 600;
  }
  & > p {
    z-index: 2;
    position: relative;
  }
  & > svg {
    z-index: 1;
  }
  img {
    position: absolute;
    z-index: 999999;
  }
  &.brainster_blog {
    img {
      top: 20px;
      right: 20px;
    }
    & > svg {
      position: absolute;
      top: -30px;
      left: 75%;
    }
    ${Header25} {
      position: absolute;
      top: 50%;
      left: 10%;
      transform: translateY(-50%);
    }
  }

  .circle {
    position: absolute;
    top: 0;
    left: 50%;
    height: 100%;
    aspect-ratio: 1 / 1;
    background-color: ${(props) => props.theme.altBlue};
    border-radius: 50%;
    transition: right 0.1s linear, left 0.1s linear;
  }
  &:hover {
    .circle {
      left: 0%;
    }

    &.media_blog {
      .circle {
        right: 0%;
      }
    }
  }
  &.media_blog {
    .circle {
      left: unset;
      right: 50%;
    }
    img {
      bottom: -20px;
      left: 30%;
    }

    & > svg {
      position: absolute;
      top: unset;
      bottom: -25px;
      left: 20%;
    }
    ${Header25} {
      position: absolute;
      top: 50%;
      right: 10%;
      transform: translateY(-50%);
    }
  }
  @media (max-width: 550px) {
    width: 317px;
    height: 130px;
    .block-mobile-shape {
      display: block;
    }
    ${Header25} {
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
    }
    & > img {
      height: 90%;
    }

    &.media_blog {
      & > img {
        height: 140%;
      }
      &.block-shape {
        display: none;
      }
    }
  }
`;

//main component
const Result = (props) => {
  const { t } = useTranslation();
  let params = useParams();
  let navigate = useNavigate();
  const referFriendInputRef = useRef();
  // States
  const { userInfo, setUserInfo, formatResultsDate, setDuration } =
    useContext(GlobalContext);
  const [result, setResult] = useState(false);
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  useEffect(() => {
    API.axios
      .get(API.createApiRoute("result", { GUID: params.guid }))
      .then(
        (response) => response.data.success && setResult(response.data.data)
      )
      .catch((error) => console.error(error.response));
    setDuration(false);
    //eslint-disable-next-line
  }, []);

  // const startChallenge = () => {
  //   setUserInfo({ ...userInfo, academy_id: params.academyId });
  //   navigate(API.createRoute("memoryGame"));
  // };

  const copyLinkToClipboard = (e) => {
    referFriendInputRef.current.select();
    document.execCommand("copy");
    referFriendInputRef.current.blur();
    setIsLinkCopied(true);
  };

  return (
    <ResultWrapper isResult={result}>
      <HeroOverlay></HeroOverlay>
      <section>
        <div className="brainster-header-container">
          <div className="brainster-logo-container">
            {/* <Link to={API.createRoute("home")} target="_blank"> */}
              <UltimathWhiteLogo />
            {/* </Link> */}
          </div>
          <Header32 color={props.theme.white}>
            🎉 Браво! Ја заврши демо играта! 🔥
          </Header32>
        </div>
        <div className="result-content-container">
   
            <div className="result-code-container">
              {/* <Caption12 color={props.theme.forestGreen}>
                Ти го постигна следниот резултат:
              </Caption12> */}

              <DemoResultContainer>
                {/* <MemoryMatrixResult>
                  <p className="score">
                    Ниво: {userInfo.memoryMatrixLevel}
                    {userInfo.memoryMatrixSublevel}
                  </p>
                  <p className="final-score">
                    Финален резултат: {userInfo.memoryMatrixResult}
                  </p>
                </MemoryMatrixResult> */}
                <Text14 color={props.theme.forestGreen} fontWeight={500}>
                  Ако си подготвен/а за вистинскиот предизвик,<br /> приклучи се на <a href="https://ultimath.mk" className="ultimath-link" target="_blank">Ultimath <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none"><path d="M1.14286 0.500002L8 0.500002L8 1.64286L1.14286 1.64286L1.14286 0.500002Z" fill="#CDF545"></path><path d="M6.85714 7.35714L6.85714 0.500002L8 0.500002L8 7.35714L6.85714 7.35714Z" fill="#CDF545"></path><path d="M5.71429 2.78572L5.71429 1.64286L6.85714 1.64286L6.85714 2.78572L5.71429 2.78572Z" fill="#CDF545"></path><path d="M4.57143 3.92857L4.57143 2.78572L5.71429 2.78572L5.71429 3.92857L4.57143 3.92857Z" fill="#CDF545"></path><path d="M3.42857 5.07143L3.42857 3.92857L4.57143 3.92857L4.57143 5.07143L3.42857 5.07143Z" fill="#CDF545"></path><path d="M2.28571 6.21429L2.28571 5.07143L3.42857 5.07143L3.42857 6.21429L2.28571 6.21429Z" fill="#CDF545"></path><path d="M1.14286 7.35714L1.14286 6.21429L2.28571 6.21429L2.28571 7.35714L1.14286 7.35714Z" fill="#CDF545"></path><path d="M0 8.5L-4.99559e-08 7.35714L1.14286 7.35714L1.14286 8.5L0 8.5Z" fill="#CDF545"></path></svg></a> и играј за победа! 🏆
                </Text14>
                <div className="button-container">
                  <div>Резултатите од <span class="demo">демо натпреварот</span></div>
                  <div>ќе бидат објавени на нашиот</div>
                   
                  <a
                    href="https://www.instagram.com/brainsternext"
                    target="_blank"
                    className="cta-link"
                  >
                    Instagram <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none"><path d="M1.14286 0.500002L8 0.500002L8 1.64286L1.14286 1.64286L1.14286 0.500002Z" fill="#CDF545"></path><path d="M6.85714 7.35714L6.85714 0.500002L8 0.500002L8 7.35714L6.85714 7.35714Z" fill="#CDF545"></path><path d="M5.71429 2.78572L5.71429 1.64286L6.85714 1.64286L6.85714 2.78572L5.71429 2.78572Z" fill="#CDF545"></path><path d="M4.57143 3.92857L4.57143 2.78572L5.71429 2.78572L5.71429 3.92857L4.57143 3.92857Z" fill="#CDF545"></path><path d="M3.42857 5.07143L3.42857 3.92857L4.57143 3.92857L4.57143 5.07143L3.42857 5.07143Z" fill="#CDF545"></path><path d="M2.28571 6.21429L2.28571 5.07143L3.42857 5.07143L3.42857 6.21429L2.28571 6.21429Z" fill="#CDF545"></path><path d="M1.14286 7.35714L1.14286 6.21429L2.28571 6.21429L2.28571 7.35714L1.14286 7.35714Z" fill="#CDF545"></path><path d="M0 8.5L-4.99559e-08 7.35714L1.14286 7.35714L1.14286 8.5L0 8.5Z" fill="#CDF545"></path></svg>
                  </a> 
                  <div class="small-text">[&nbsp;денес во 18:00&nbsp;]</div>
                </div>
              </DemoResultContainer>
            </div>
     
        </div>
        <div className="cta-container">
          <div></div>
          <Header25 color={props.theme.altBlack} fontWeight={600}>
            {t("result.cta.header")}
          </Header25>
          <div className="blogs-container">
            <div className="brainster-next-cover-wrap">
              <a href="https://next.edu.mk/" target="_blank">
                <div className="overlay">
                  <div className="brainster-next-logo-container">
                    <BrainsterNextLogo />
                    <p className="title">
                      Aкредитиран практичен <br />
                      IT факултет
                    </p>
                  </div>
                </div>
              </a>
              <img src={brainsterNextCover} alt="" />
            </div>
            <div className="ultimath-cover-wrap">
              <a href="https://nucollege.ai/" target="_blank">
                <div className="overlay">
                  <div className="brainster-next-logo-container">
                    <NUCollegeLogo />
                    <p className="title">
                      Прв кoлеџ за <br />
                      средношколци
                    </p>
                  </div>
                </div>
              </a>
              <img src={ultimathCover} alt="" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </ResultWrapper>
  );
};

export default withTheme(Result);
